import { motion } from "framer-motion";

const services = [
  {
    n: "01",
    title: "Junk Removal",
    tag: "Residential · Commercial",
    body: "From single-item pickup to whole-house cleanouts. Furniture, appliances, estate leftovers, garage overflow — we sort, haul, and dispose responsibly across Central Alabama.",
    image: "https://images.unsplash.com/photo-1719003361901-bf35eb12c47f?w=940&h=1175&fit=crop&q=80",
    testid: "service-junk",
  },
  {
    n: "02",
    title: "Demolition",
    tag: "Structures · Interiors",
    body: "Interior tear-outs, sheds, decks and small outbuildings — taken down safely and cleared off the property in one visit.",
    image: "https://images.unsplash.com/photo-1671575877432-c80381ec66b5?w=940&h=1175&fit=crop&q=80",
    testid: "service-demolition",
  },
  {
    n: "03",
    title: "Site Cleanup",
    tag: "Construction · Post-Storm",
    body: "Post-construction sweeps, storm debris, foreclosure cleanouts and property refresh.",
    image: "https://images.unsplash.com/photo-1602262442764-c14f8db98045?w=940&h=1175&fit=crop&q=80",
    testid: "service-cleanup",
  },
];

const ServiceCard = ({ s, i }) => {
  return (
    <motion.article
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.25 }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1], delay: i * 0.1 }}
      className="service-card group border-t border-navy pt-6"
      data-testid={s.testid}
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-bone mb-6">
        <img
          src={s.image}
          alt={s.title}
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
        />
        <div className="absolute bottom-4 left-4 text-[9px] tracking-[0.3em] uppercase text-white font-semibold bg-navy/80 px-2 py-1">
          {s.tag}
        </div>
      </div>

      <h3 className="font-display font-black uppercase text-navy text-2xl md:text-3xl leading-none mb-3 tracking-tight">
        {s.title}
      </h3>
      <p className="text-slate-600 leading-relaxed text-[15px] max-w-sm">{s.body}</p>
    </motion.article>
  );
};

export default function Services() {
  return (
    <section id="services" className="bg-white py-24 md:py-40 border-b border-navy/10" data-testid="services-section">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 mb-16 md:mb-24">
          <div className="md:col-span-3" />
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 1, ease: [0.76, 0, 0.24, 1] }}
            className="md:col-span-9 font-display font-black uppercase text-navy tracking-[-0.02em] leading-[0.9] text-4xl md:text-6xl lg:text-7xl"
            data-testid="services-heading"
          >
            <span className="italic font-medium text-navy pr-4">What</span>we offer!
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {services.map((s, i) => (
            <ServiceCard key={s.n} s={s} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
